var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","stroke":"#4a4aff","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"1.8","d":"M24.08 6.2v3.27","key":0}),React.createElement("path",{"fill":"none","stroke":"#4a4aff","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"1.8","d":"m28.26 25.09-2.94 1.86a1 1 0 0 1-1.54-.85V14.64a1 1 0 0 0-1.36-.94l-2.67.99","key":1}),React.createElement("path",{"fill":"none","stroke":"#3b4b6f","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.8","d":"M16.33.9h12.83A15.43 15.43 0 0 1 44.6 16.33v15.42h0-28.26A15.43 15.43 0 0 1 .9 16.33h0A15.43 15.43 0 0 1 16.33.9Z","key":2})]);
}

Info.defaultProps = {"width":"45.49","height":"32.65"};

module.exports = Info;

Info.default = Info;
